module.exports = __webpack_public_path__ + "static/media/driver2.ed04caba.png";